// extracted by css-extract-rspack-plugin
export default {"features":"EAxgbwERS2MjFJKT","featureName":"lYx2o80fjM7aIewR","featureDescription":"BschC_on4wAccn56"};